/**
 * Slots de publicidad en el home del catálogo: cada espacio tiene su propio `valido_hasta`.
 * Compat: si un ítem no tiene `valido_hasta`, se usa el del documento (`doc.valido_hasta`) si existe.
 * CTA: cada slot debe traer `vendedor_uid` (UID Firebase Auth). Sin UID válido el slot se descarta.
 */

function uidSlotOk(d) {
  return d && /^[A-Za-z0-9_-]{10,128}$/.test(String(d.vendedor_uid || '').trim());
}

/** @param {object|null|undefined} row @param {object|null|undefined} docGlobal */
export function validoHastaSlotMs(row, docGlobal) {
  const h = row?.valido_hasta;
  if (h != null && typeof h.toMillis === 'function') return h.toMillis();
  const g = docGlobal?.valido_hasta;
  if (g != null && typeof g.toMillis === 'function') return g.toMillis();
  return null;
}

/**
 * ¿El ítem se muestra en el catálogo ahora? (contenido + ventana de tiempo)
 * @param {object} row
 * @param {object|null|undefined} docGlobal
 */
export function slotPublicidadCatalogoVigente(row, docGlobal, nowMs = Date.now()) {
  if (!row || typeof row !== 'object') return false;
  const end = validoHastaSlotMs(row, docGlobal);
  if (end == null) return true;
  return nowMs < end;
}

export function slotsPublicidadHomeDesdeDoc(doc, nowMs = Date.now()) {
  const rawNeg = doc?.negocio_dia && typeof doc.negocio_dia === 'object' ? doc.negocio_dia : null;
  const tituloNeg = String(rawNeg?.titulo || '').trim();
  const uidNeg = String(rawNeg?.vendedor_uid || '').trim();
  let negOk =
    tituloNeg && /^[A-Za-z0-9_-]{10,128}$/.test(uidNeg)
      ? { ...rawNeg, titulo: tituloNeg, vendedor_uid: uidNeg }
      : null;
  if (negOk && !slotPublicidadCatalogoVigente(negOk, doc, nowMs)) negOk = null;

  let destacadosItems = [];
  if (Array.isArray(doc?.destacados_items) && doc.destacados_items.length) {
    destacadosItems = doc.destacados_items
      .map((row) => {
        if (
          !row ||
          typeof row !== 'object' ||
          !uidSlotOk(row) ||
          !String(row.titulo || '').trim() ||
          !slotPublicidadCatalogoVigente(row, doc, nowMs)
        ) {
          return null;
        }
        const pid = String(row.producto_id || '').trim();
        return pid ? { ...row, producto_id: pid } : { ...row };
      })
      .filter(Boolean)
      .slice(0, 2);
  }

  const rawCom = Array.isArray(doc?.comercios_barrio) ? doc.comercios_barrio : [];
  const comercios = rawCom
    .filter(
      (row) =>
        row &&
        typeof row === 'object' &&
        String(row.titulo || '').trim() &&
        uidSlotOk(row) &&
        slotPublicidadCatalogoVigente(row, doc, nowMs)
    )
    .slice(0, 6);

  return { negocio: negOk, destacadosItems, comercios };
}

export function productoValidoParaCatalogoHome(it) {
  if (!it?.id) return false;
  if (String(it.estado || '') !== 'publicado') return false;
  return true;
}
